<template>
  <div>
    <v-row id="create" class="ma-0">
      <v-col cols="12" class="px-0 py-0">
        <!-- 1.캘린더 헤더 (일자선택) -->
        <v-sheet height="48">
          <v-toolbar flat height="48">
            <v-btn fab text small color="grey darken-2" @click="prev">
              <v-icon color="grey"> mdi-chevron-left </v-icon>
            </v-btn>
            <v-spacer></v-spacer>
            <v-toolbar-title v-if="$refs.calendar" class="month-title">
              {{ title }}
            </v-toolbar-title>
            <v-spacer></v-spacer>
            <v-btn fab text small color="grey darken-2" @click="next">
              <v-icon color="grey"> mdi-chevron-right </v-icon>
            </v-btn>
          </v-toolbar>
        </v-sheet>

        <!-- 2. 캘린더 내용 -->
        <v-sheet style="height: calc(100vh - 160px); position: relative">
          <v-calendar
            ref="calendar"
            v-model="focus"
            color="primary"
            type="month"
            :events="events"
            :event-color="getEventColor"
            :event-text-color="getEventTextColor"
            :weekday-format="getDay"
            :month-format="getMonth"
            @click:day="openDetailModal"
            @change="updateRange"
            min-weeks="6"
          >
          </v-calendar>

          <!-- 3. 일정추가 버튼 -->
          <v-speed-dial
            v-if="GET_APPL_MENU_USE_YN"
            v-model="fab"
            :bottom="bottom"
            :right="right"
            :open-on-hover="hover"
            fixed
            :style="`bottom:${dialBottomByOs}px!important;`"
          >
            <template v-slot:activator>
              <v-btn
                v-model="fab"
                color="blue"
                @click="goApplMenuList()"
                dark
                fab
              >
                <v-icon> mdi-plus </v-icon>
              </v-btn>
            </template>
          </v-speed-dial>
        </v-sheet>
      </v-col>
    </v-row>

    <calendar-detail-dialog
      v-bind:detailObjProps="detailObj"
      v-bind:applBtnFlag="GET_APPL_MENU_USE_YN"
      v-on:goApplMenuList="goApplMenuList"
    ></calendar-detail-dialog>
  </div>
</template>

<script>
/* 캘린더 컴포넌트 */
import CalendarDetailDialog from '@/components/calendar/dialog/CalendarDetailDialog.vue';
import { mapGetters } from 'vuex';
import { getPsnlCalendarMonList } from '@/api/calendar.js';
import routerConstants from '@/const/routerConstants.js';
import dayjs from 'dayjs';
import isBetween from 'dayjs/plugin/isBetween';
import 'dayjs/locale/ko';

dayjs.extend(isBetween);
dayjs.locale('ko');

export default {
  data: () => ({
    calendarDate: '',
    title: '', // 캘린더 타이틀
    events: [], // 캘린더 일정목록
    focus: '',

    dailyInOutTimeObj: {}, // 일별출퇴근시간
    detailObj: {}, // 일정상세

    // 일정추가버튼 관련
    fab: false,
    hover: false,
    right: true,
    bottom: true,

    // 근태 텍스트 컬러 (고정, '_attendanceChip.scss'참고)
    gntTextColorObj: {
      bcFFD49A: 'ff7936',
      bcFFE79A: 'ff9204',
      bcA6E5BA: '0fa941',
      bc9CCBFC: '087ef7',
      bcD7DADD: '505961',
    },
  }),

  watch: {
    top(val) {
      this.bottom = !val;
    },
    right(val) {
      this.left = !val;
    },
    bottom(val) {
      this.top = !val;
    },
    left(val) {
      this.right = !val;
    },
  },

  computed: {
    ...mapGetters(['IS_IOS']),
    ...mapGetters('MENU', ['GET_APPL_MENU_USE_YN']),

    /* os별 dial bottom 추출 */
    dialBottomByOs() {
      return this.IS_IOS ? '112' : '94';
    },
  },

  methods: {
    /* 기간 이전이후 선택 */
    prev() {
      this.$refs.calendar.prev();
    },
    next() {
      this.$refs.calendar.next();
    },

    /* 캘린더 포맷 - 요일, 월 */
    getDay(date) {
      const daysOfWeek = ['일', '월', '화', '수', '목', '금', '토'];
      return daysOfWeek[date.weekday];
    },
    getMonth(date) {
      const monthName = [
        '1월',
        '2월',
        '3월',
        '4월',
        '5월',
        '6월',
        '7월',
        '8월',
        '9월',
        '10월',
        '11월',
        '12월',
      ];
      return monthName[date.month - 1];
    },

    /* 캘린더 일정 컬러 */
    getEventColor(event) {
      return event.color;
    },
    getEventTextColor(event) {
      return event.textColor;
    },

    /* 캘린더 변경이벤트 : 초기or기간변경시 -> 일정 및 캘린더타이틀 세팅 */
    updateRange({ start }) {
      // +. 공통 스피너 ON
      this.$store.commit('SPINNER/ON_COMMON_SPINNER');

      // 1. 캘린더 타이틀 세팅 (format : 'YYYY년 MM월')
      const startDate = dayjs(start.date);
      this.title = startDate.format('YYYY년 MM월');
      this.calendarDate = startDate.format('YYYYMM');

      // 2. 월단위 캘린더 목록조회
      this.getPsnlCalendarMonList();
    },

    /* 일자 클릭이벤트 : 일정상세 모달 호출 */
    openDetailModal(param) {
      const paramDate = dayjs(param.date);

      // 0. 지난/다음달의 일자 클릭한 경우 즉시종료 (캘린더 6주 표기로 인한 방어로직)
      if (this.calendarDate !== paramDate.format('YYYYMM')) {
        return;
      }

      // 1. 클릭한 일자에 해당되는 근태현황을 추출
      const dailyEventList = this.events.filter(
        evt =>
          paramDate.isBetween(evt.start, evt.end, 'day', '[]') &&
          evt.gubun != 1,
      );

      // 2. 일정상세 모달로 전달할 파라미터 세팅
      this.detailObj = {
        dayTitle: paramDate.format('YYYY년 MM월 DD일(ddd)'),
        dailyInOutTime: this.dailyInOutTimeObj[`${param.date}`],
        dailyEventList,
      };

      // 3. 모달 오픈
      this.$store.commit('DIALOG/TOGGLE_MODAL', 'calendar_detail');
    },

    /* 신청서 작성 화면이동 */
    goApplMenuList() {
      this.$router.push({ name: routerConstants.ApplicationMenu }); // 신청서메뉴페이지로 이동
    },

    /* 월단위 캘린더 목록조회 */
    async getPsnlCalendarMonList() {
      try {
        // 1. api 호출
        const response = await getPsnlCalendarMonList({
          searchYm: this.calendarDate,
        });
        const dataList = response.data.data;

        // 2. 초기화
        let event = [];
        this.dailyInOutTimeObj = {};

        // 3. 조회결과 추출
        dataList.forEach(item => {
          // 3-a. 인정근무출퇴근시간
          if (item.gubun == 2) {
            this.dailyInOutTimeObj[item.sYmd] = item.title;
          }
          // 3-b. 휴일, 근태(승인완료건만)
          else if (item.gubun == 1 || item.gubun == 91) {
            let backColor = '#ffbebe'; // 기본 : 휴일컬러
            let textColor = '#ff4565';

            if (item.cls != null) {
              backColor = `#${item.cls.substr(2).toLocaleLowerCase()}`;
              textColor = `#${this.gntTextColorObj[item.cls]}`;
            }

            event.push({
              name: item.title,
              start: item.sYmd,
              end: item.eYmd,
              color: backColor,
              textColor: textColor,
              timed: true,
              applSeq: item.applSeq,
              gubun: item.gubun,
            });
          }
        });

        // 4. 캘린더 일정 추가
        this.events = event;

        // +. 공통 스피너 OFF
        this.$store.commit('SPINNER/OFF_COMMON_SPINNER');
      } catch (error) {
        console.log(error);
        // 공통 스피너 OFF
        this.$store.commit('SPINNER/OFF_COMMON_SPINNER');
      }
    },
  },

  mounted() {
    this.$refs.calendar.checkChange();
  },

  components: {
    CalendarDetailDialog,
  },
};
</script>

<style>
.v-speed-dial--right {
  right: 24px !important;
}
/* .v-speed-dial--bottom {
  bottom: 94px !important;
} */
</style>
